import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_2 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Select")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Item")
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "font-semibold text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "text-gray-600" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Price")
const _hoisted_9 = { class: "text-gray-600 whitespace-nowrap" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Status")
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "py-8 text-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 font-medium text-gray-900" }, "Nothing to ship!", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm" }, " There a no orders waiting to ship. Good job! ", -1)
const _hoisted_15 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Mark As Shipped ")
const _hoisted_17 = {
  key: 0,
  class: "bg-indigo-100 text-indigo-600 px-1 py-0.5 rounded-md text-xs ml-1 -mr-1"
}

import { useOrders } from "@/composables/orders";
import { computed, PropType, ref } from "vue";
import DefaultTable from "@/components/DefaultTable.vue";
import OrderStatusBadge from "@/components/OrderStatusBadge.vue";
import { formatDistanceToNow, parseISO } from "date-fns";
import { CheckIcon, InboxIcon, ExclamationIcon } from "@heroicons/vue/solid";
import Checkbox from "@/components/Checkbox.vue";
import { orderBy, pick, some, sortBy } from "lodash";
import { IOrder } from "@/utils/IOrder";
import Button from "@/components/Button.vue";
import TableSkeleton from "@/components/skeletons/TableSkeleton.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  selected: {
    type: Array as PropType<IOrder[]>,
    required: true,
  },
},
  emits: ["update:selected", "create-shipment"],
  setup(__props, { emit }) {

const props = __props



const WARNING_DAYS = 6.5;



const { orders: allOrders, isLoading, isReady } = useOrders();

const orders = computed(() =>
  orderBy(
    allOrders.value.filter(
      (val) => val.status === "ORDERED" && val.supplierStatus !== "FULFILLED"
    ),
    ["statusLastUpdatedAt"],
    ["desc"]
  ).reverse()
);

const isSelected = (o: IOrder) => {
  return some(props.selected, pick(o, ["id"]));
};

const setSelected = (o: IOrder, addOrRemove: boolean) => {
  if (addOrRemove) {
    emit("update:selected", [...props.selected, o]);
  } else {
    emit(
      "update:selected",
      props.selected.filter((o2) => o2.id !== o.id)
    );
  }
};

const toggleSelected = (o: IOrder) => setSelected(o, !isSelected(o));

const daysSince = (dateString: string) => {
  let date = parseISO(dateString);
  return (Date.now() - date.getTime()) / (86400 * 1000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_unref(isReady) || _unref(isLoading))
          ? (_openBlock(), _createBlock(TableSkeleton, { key: 0 }))
          : (_unref(orders).length > 0)
            ? (_openBlock(), _createBlock(DefaultTable, {
                key: 1,
                columns: ['selected', 'name', 'cost', 'status', 'time'],
                rows: _unref(orders)
              }, {
                "th-selected": _withCtx(() => [
                  _hoisted_3
                ]),
                "td-selected": _withCtx(({ row: order }) => [
                  _createVNode(Checkbox, {
                    modelValue: isSelected(order),
                    "onUpdate:modelValue": ($event: any) => (setSelected(order, $event))
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                "th-name": _withCtx(() => [
                  _hoisted_4
                ]),
                "td-name": _withCtx(({ row: order }) => [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(order.name), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(order.supplier) + " " + _toDisplayString(order.origin) + " " + _toDisplayString(order.supplierRef), 1)
                  ])
                ]),
                "th-cost": _withCtx(() => [
                  _hoisted_8
                ]),
                "td-cost": _withCtx(({ row: order }) => [
                  _createElementVNode("span", _hoisted_9, " $" + _toDisplayString(order.costPriceUsd) + " USD ", 1)
                ]),
                "th-status": _withCtx(() => [
                  _hoisted_10
                ]),
                "td-status": _withCtx(({ row: order }) => [
                  _createVNode(OrderStatusBadge, {
                    value: order.status
                  }, null, 8, ["value"])
                ]),
                "td-time": _withCtx(({ row: order }) => [
                  _createElementVNode("span", {
                    class: _normalizeClass(["whitespace-nowrap flex items-center", 
                daysSince(order.statusLastUpdatedAt) >= WARNING_DAYS
                  ? 'text-red-500'
                  : 'text-gray-500'
              ])
                  }, [
                    (daysSince(order.statusLastUpdatedAt) >= WARNING_DAYS)
                      ? (_openBlock(), _createBlock(_unref(ExclamationIcon), {
                          key: 0,
                          class: "w-4 h-4 text-red-500 mr-1"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_unref(formatDistanceToNow)(_unref(parseISO)(order.statusLastUpdatedAt), {
                  addSuffix: true,
                })), 1)
                  ], 2)
                ]),
                _: 1
              }, 8, ["rows"]))
            : (_unref(orders).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(InboxIcon), { class: "text-gray-400 w-8 h-8 block mx-auto" }),
                    _hoisted_13,
                    _hoisted_14
                  ])
                ]))
              : _createCommentVNode("", true)
      ])
    ]),
    (_unref(orders).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(Button, {
            class: "disabled-opacity",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('create-shipment'))),
            disabled: __props.selected.length === 0
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              (__props.selected.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(__props.selected.length), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})